<template>
  <div class="carousel-wrap">
    <div class="mask-transition" ref="mask">
      <div class="mask-bg"></div>
    </div>
    <div class="images-wrap">
      <img v-for="(image, index) in imagesArray" 
        :key="index" 
        :class="indexActive === index ? 'show' : ''"
        :src="require('../../assets/images/' +image)"
        />
    </div>
  </div>
</template>

<script>
import {TweenMax,TimelineMax,Expo} from 'gsap';

export default {
  name: 'CarouselProds',
  props: ['indexActive', 'imagesArray', 'canToggle'],
  methods:{

  },
  mounted(){

  },
  watch:{
    indexActive(newVal){
      this.$emit('update:canToggle', false)
      this.$refs.mask.classList.add('translate');
      let bg = this.$refs.mask.querySelector('.mask-bg')
      let TL = new TimelineMax();

      TL
      .add(TweenMax.fromTo(this.$refs.mask, .65,{x: '100%'}, {x:0, ease: Expo.easeInOut}))
      .add(TweenMax.fromTo(bg, .25,{scaleX: 1},{scaleX:0, ease: Expo.easeInOut}, '-=.25'))


      setTimeout(()=>{
        
        this.$emit('update:canToggle', true)
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .carousel-wrap{
    position: relative;
    width: 100%;
    overflow: hidden;
    @media screen and (max-width: 900px){
      height: 100%;
    }
    .mask-transition{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      transform: translateX(100%);
      overflow: hidden;
      z-index: 3;
      width: 100%;
      transform-origin: 0% 100%;
      .mask-bg{
        position: relative;
        width: 100%;
        transform-origin: 0% 100%;
        height: 100%;
        background-color: #F5F5F5;
      }
    }
    .images-wrap{
      position: relative;
      img{
        position: absolute !important;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: 1;
        transition-property: opacity ;
        transition-duration: 0s ;
        transition-delay: .5s;
        &.show{
          position: relative !important;;
          opacity: 1;
          z-index: 2;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CarouselProds.vue?afa137fc